export default {
  gutterBottom: {
    marginBottom: 8,
  },
} as const;
